import { render, staticRenderFns } from "./KundeProfile.vue?vue&type=template&id=bd7ad58a&scoped=true&"
import script from "./KundeProfile.vue?vue&type=script&lang=js&"
export * from "./KundeProfile.vue?vue&type=script&lang=js&"
import style1 from "./KundeProfile.vue?vue&type=style&index=1&id=bd7ad58a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7ad58a",
  null
  
)

export default component.exports